import { useInfiniteQuery, useQuery } from "@tanstack/react-query";

import { GO_SERVICE_QUERY_KEYS } from "../queryKeys";
import { getTopServiceProviders } from "../services/goHireService";
import { TopServiceProvidersParams, TopServiceProvidersResponse } from "../types/topServiceProviders.types";

export const DEFAULT_PROVIDERS_LIMIT = 20;
export const DEFAULT_PROVIDERS_OFFSET = 0;

export const useTopServiceProviders = ({
  limit = DEFAULT_PROVIDERS_LIMIT,
  offset = DEFAULT_PROVIDERS_OFFSET,
  countryIds,
  type,
  categories,
  rating,
  availabilityOption,
  role,
}: TopServiceProvidersParams = {}) => {
  return useQuery({
    queryKey: [
      ...GO_SERVICE_QUERY_KEYS.topServiceProviders(),
      { limit, offset, countryIds, type, categories, rating, availabilityOption, role },
    ],
    queryFn: () =>
      getTopServiceProviders({ limit, offset, countryIds, type, categories, rating, availabilityOption, role }),
  });
};

export const useInfiniteTopServiceProviders = (limit: number = DEFAULT_PROVIDERS_LIMIT) => {
  return useInfiniteQuery<TopServiceProvidersResponse>({
    queryKey: [...GO_SERVICE_QUERY_KEYS.topServiceProviders(), { limit }],
    initialPageParam: DEFAULT_PROVIDERS_OFFSET,
    queryFn: ({ pageParam }) => getTopServiceProviders({ offset: pageParam as number, limit }),
    getNextPageParam: (lastPage) => {
      const nextOffset = lastPage.meta.currentPage * lastPage.meta.itemsPerPage + lastPage.meta.itemsPerPage;
      if (nextOffset < lastPage.meta.totalItems) {
        return nextOffset;
      }
      return undefined;
    },
    getPreviousPageParam: (firstPage) => {
      const previousOffset = (firstPage.meta.currentPage - 1) * firstPage.meta.itemsPerPage;
      if (previousOffset >= 0) {
        return previousOffset;
      }
      return undefined;
    },
  });
};
